module.exports = __webpack_public_path__ + "static/media/elephant_line.d7f2904c.svg";